import type {
  NotificationType,
  ServerNotification,
} from '@openeducation/oe-it-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces/environment';
import { hostsConfig } from '../utils';

export default abstract class NotificationDao {
  static async getNotifications(
    env: Environment,
    teacherId: number,
    notificationType?: NotificationType
  ) {
    const baseUrl = hostsConfig[env].notificationServiceUrl;

    const params = {
      personId: teacherId,
      type: notificationType || undefined,
    };

    const { data } = await axios.get<ServerNotification[] | undefined>(
      `${baseUrl}/v1/teacher/notifications`,
      { params }
    );

    return data;
  }

  static async acknowledge(
    env: Environment,
    notificationId: string,
    personId: number
  ) {
    const url = hostsConfig[env].notificationServiceUrl;
    const { data } = await axios.put(
      `${url}/notifications/${notificationId}?personId=${personId}`
    );
    return data;
  }

  static async confirm(
    env: Environment,
    notificationId: string,
    personId: number
  ) {
    const url = hostsConfig[env].notificationServiceUrl;
    const { data } = await axios.post(
      `${url}/notifications/confirm/${personId}/${notificationId}`
    );
    return data;
  }
}
